import echart, { EChartOption, EChartsResponsiveOption, ECharts } from 'echarts'
import { getTitleStringByType, getEveryDayDateStringList } from '@/utils/date'

export const drawCompanySpendingehart = (chart: ECharts, data: any, filter: any) => {
  let mapper: any = {
    'balance': '余额消费',
    'card': '卡片消费',
    'wepay': '微信消费'
  }
  let legend: any = {}
  let balanceData: any = []
  let cardData: any = []
  let wepayData: any = []

  let showBalance = false
  let showCard = false
  let showWepay = false

  for (let item of data) {
    legend[mapper[item.type]] = 0
    let value = parseFloat(parseFloat(item.total).toFixed(2))
    if (item.type === 'balance') {
      balanceData.push(value)
      cardData.push(0)
      wepayData.push(0)
      showBalance = true
    } else if (item.type === 'card') {
      cardData.push(value)
      balanceData.push(0)
      wepayData.push(0)
      showCard = true
    } else if (item.type === 'wepay') {
      showWepay = true
      wepayData.push(value)
      balanceData.push(0)
      cardData.push(0)
    }
  }
  let seriesData: any = []
  if (showBalance) {
    seriesData.push({
      name: '余额消费',
      type: 'line',
      markLine: {
        data: [{ type: 'average', name: '平均值' }]
      },
      data: balanceData
    })
  }
  if (showCard) {
    seriesData.push({
      name: '卡片消费',
      type: 'line',
      markLine: {
        data: [{ type: 'average', name: '平均值' }]
      },
      data: cardData
    })
  }
  if (showWepay) {
    seriesData.push({
      name: '微信消费',
      type: 'line',
      markLine: {
        data: [{ type: 'average', name: '平均值' }]
      },
      data: wepayData
    })
  }

  chart.setOption({
    title: {
      text: '车队消费数据'
    },
    tooltip: {
      trigger: 'axis',
      formatter: '{b}: {c}￥'
    },
    xAxis: {
      data: data.map((item: any) => {
        let date = new Date(item.date)
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
      })
    },
    yAxis: {},
    legend: {
      data: legend.keys
    },
    series: seriesData
  })
}
